import { useCallback, useRef, useState } from 'react';

export const useGuardedAsyncCallback = <Args extends unknown[]>(
  callback: (...args: Args) => Promise<void>,
) => {
  const isPendingRef = useRef(false);
  const [isPending, setIsPending] = useState(false);
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const guardedCallback = useCallback(async (...args: Args) => {
    if (isPendingRef.current) return;

    isPendingRef.current = true;
    setIsPending(true);

    try {
      await callbackRef.current(...args);
    } finally {
      isPendingRef.current = false;
      setIsPending(false);
    }
  }, []);

  return { callback: guardedCallback, isPending };
};
